export default __webpack_public_path__ + "static/media/ax-logo-light.486b396c.JPG";